const THREADS = [
  [
    {
      id: 'c1',
      user: 'Rafi',
      text: 'wah keren ini',
      time: '2j',
      replies: [
        { id: 'c1r1', user: 'Maya', text: 'masih bisa dicek belum?', time: '1j' },
        { id: 'c1r2', user: 'Andi', text: 'pagi tadi masih ada', time: '51m' },
      ],
    },
    {
      id: 'c2',
      user: 'Lina',
      text: 'namaku ada ga ya',
      time: '40m',
      replies: [],
    },
  ],
  [
    {
      id: 'c3',
      user: 'Dimas',
      text: 'ini yang voucher kan',
      time: '3j',
      replies: [{ id: 'c3r1', user: 'Sari', text: 'iya hadiah member', time: '2j' }],
    },
    {
      id: 'c4',
      user: 'Budi',
      text: 'ok tak coba',
      time: '25m',
      replies: [],
    },
  ],
];

const AVATAR_COLORS = ['#0F766E', '#D97706', '#2563EB', '#DB2777', '#7C3AED', '#EA580C'];

function hashId(id) {
  const s = String(id || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function cloneThread(thread) {
  return (thread || []).map((comment) => ({
    ...comment,
    replies: (comment.replies || []).map((reply) => ({ ...reply })),
  }));
}

/**
 * Shape follows the upcoming Social Banner program module.
 * Swap SOCIAL_BANNER_PROGRAMS.
 */
export const SOCIAL_BANNER_PROGRAMS = [
  {
    id: 'sb_1',
    description: 'List pemenang motor listrik & Jouzoo RDA sudah keluar. Cek namamu ya.',
    image_landscape: 'https://placehold.co/780x290/111827/FFFFFF/png?text=Pemenang+Motor+Listrik&font=poppins',
    image_portrait: 'https://placehold.co/450x600/111827/FFFFFF/png?text=Pemenang+Motor+Listrik&font=poppins',
    share_url: 'https://local-club.zoolyfe.id/social/sb_1',
    link: 'https://local.zoolyfe.id/',
    liked_by_me: false,
    like_count: 214,
    comments: cloneThread(THREADS[0]),
  },
  {
    id: 'sb_2',
    description: 'Hadiah member bulan ini masih jalan. Periode 1–31 Agustus.',
    image_landscape: 'https://placehold.co/780x290/0F172A/FFFFFF/png?text=Hadiah+Member+Bulan+Ini&font=poppins',
    image_portrait: 'https://placehold.co/450x600/0F172A/FFFFFF/png?text=Hadiah+Member&font=poppins',
    share_url: 'https://local-club.zoolyfe.id/social/sb_2',
    link: null,
    liked_by_me: false,
    like_count: 86,
    comments: cloneThread(THREADS[1]),
  },
];

export function getDemoSocialSeed(itemId) {
  const program = SOCIAL_BANNER_PROGRAMS.find((p) => p.id === itemId);
  if (program) {
    return {
      liked: !!program.liked_by_me,
      likeCount: program.like_count,
      comments: cloneThread(program.comments),
    };
  }
  return {
    liked: false,
    likeCount: 0,
    comments: [],
  };
}

export function avatarColorForName(name) {
  const h = hashId(name || '?');
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export function countComments(comments) {
  return (comments || []).reduce(
    (sum, comment) => sum + 1 + (comment.replies ? comment.replies.length : 0),
    0
  );
}

export function getPromoShareUrl(item) {
  if (item?.share_url) return item.share_url;
  if (item?.id) return `https://local-club.zoolyfe.id/social/${item.id}`;
  return 'https://local-club.zoolyfe.id/MainTabs/Home';
}

export function getPromoShareText(item) {
  return item?.description || '-';
}

export function getPromoShareSenderName(currentUser) {
  const raw = (currentUser?.name || '').trim();
  if (!raw) return 'Kawan Zoolyfe';
  return raw.split(' ')[0] || 'Kawan Zoolyfe';
}

export function getPromoShareRecipientName(recipientName) {
  const raw = (recipientName || '').trim();
  return raw || 'Kawan';
}

/**
 * Standardized share copy. Link line is always "Klik disini: {url}".
 */
export function getPromoShareMessage(item, url, { senderName, recipientName } = {}) {
  const recipient = getPromoShareRecipientName(recipientName);
  const sender = getPromoShareSenderName({ name: senderName });

  return [
    `Hi ${recipient},`,
    '',
    `ada info menarik nih dari Zoolyfe`,
    '',
    ...(item?.description && item.description.trim() !== `` ? [`"${(item?.description || `-`)}"`, ''] : []),
    `Penasaran kan? Klik disini yaa: ${url}`,
  ].join('\n');
}

export function getBannerFeedImage(item) {
  return item?.image_landscape || item?.image_portrait || null;
}

export function getBannerDetailImage(item) {
  return item?.image_portrait || item?.image_landscape || null;
}

export function getBannerLink(item) {
  const link = item?.link;
  if (!link) return null;
  if (typeof URL !== 'undefined' && URL.canParse && URL.canParse(link)) {
    return link;
  }
  return null;
}
